module.exports = __webpack_public_path__ + "static/14-Guest-room-efe59a9e9cab96993fe82b31448e4b56.jpg";